<div class="side-nav flex flex-col h-full bg-white" [class.side-nav--collapsed]="collapsed()">
  <div class="px-4 pt-6 pb-8">
    <xemex-nav-brand [collapsed]="collapsed()" />
  </div>

  <nav class="flex-1 flex flex-col gap-1 px-3 overflow-y-auto">
    @for (group of groups(); track $index) {
      @if (group.section && !collapsed()) {
        <span class="side-nav__section-header px-3 pt-3 pb-1">{{ group.section | translate }}</span>
        <div class="side-nav__section-items flex flex-col gap-1 ml-3 pl-3">
          @for (item of group.items; track $index) {
            <ng-container [ngTemplateOutlet]="navLink" [ngTemplateOutletContext]="{ $implicit: item }" />
          }
        </div>
      } @else {
        @for (item of group.items; track $index) {
          <ng-container [ngTemplateOutlet]="navLink" [ngTemplateOutletContext]="{ $implicit: item }" />
        }
      }
    }
  </nav>

  <ng-template #navLink let-item>
    <a [routerLink]="item.link" routerLinkActive #rla="routerLinkActive" class="no-underline">
      <xemex-nav-button
        [icon]="item.icon"
        [label]="item.label | translate"
        [active]="rla.isActive"
        [collapsed]="collapsed()"
        [badge]="item.badge ?? 0"
        [badgeTooltip]="item.badgeTooltip ? (item.badgeTooltip | translate) : ''"
      />
    </a>
  </ng-template>

  <div class="side-nav__bottom flex flex-col gap-1 px-3 pt-6 pb-6">
    @for (item of bottomItems(); track $index) {
      @if (item.externalUrl) {
        <a [href]="item.externalUrl" target="_blank" rel="noopener noreferrer" class="no-underline">
          <xemex-nav-button
            [icon]="item.icon"
            [label]="item.label | translate"
            [active]="false"
            [collapsed]="collapsed()"
          />
        </a>
      } @else {
        <a
          [routerLink]="item.link"
          routerLinkActive
          #rlaBottom="routerLinkActive"
          class="no-underline"
        >
          <xemex-nav-button
            [icon]="item.icon"
            [label]="item.label | translate"
            [active]="rlaBottom.isActive"
            [collapsed]="collapsed()"
          />
        </a>
      }
    }
  </div>
</div>
